import { useInfiniteQuery } from '@tanstack/react-query'
import { useStore } from '@tanstack/react-store'
import { api } from 'api'
import { DocumentsListFilter, documentsListStore } from 'shared/store/documentsList'
import { checkParam } from 'shared/utils/checkParam'
import { toaster } from 'uikit/Toaster'

export const useFetchDocumentsList = ({ urlParams }: { urlParams: DocumentsListFilter }) => {
  const { filter: storeFilter } = useStore(documentsListStore)
  const params = { ...storeFilter, ...urlParams }

  let list = []
  let lastPage

  const query = useInfiniteQuery({
    queryKey: ['documentsList', params],
    queryFn: ({ pageParam }) => {
      return api.documents.fetchList({
        ...params,
        page: pageParam,
        size: 20,
        removed: checkParam(params.removed),
        style: checkParam(params.style),
      })
    },
    initialPageParam: 0,
    getNextPageParam: ({ page }) => page + 1,
  })

  if (query.isError) {
    toaster.create({
      type: 'error',
      title: 'Произошла ошибка при загрузке документов',
      description: query.error?.message,
    })
  }

  if (query.data?.pages) {
    const content = query.data.pages.reduce((acc, item) => [...acc, ...(item.documents || [])], [])
    list = content?.length ? content : []
    lastPage = query.data.pages[query.data.pages.length - 1]
  }

  return {
    list,
    hasMore: lastPage?.page < lastPage?.totalPages - 1,
    lastPage,
    totalElements: lastPage?.totalElements || 0,
    ...query,
  }
}
